import { useContextSelector } from "use-context-selector";
import { IframeContext } from "../contexts/IFrameContext";

export function useSendSetFullScreen() {
  return useContextSelector(
    IframeContext,
    (iframe) => iframe.sendSetFullScreen
  );
}
